import { useMutation, useQueryClient } from '@tanstack/react-query';
import { myProfileApi } from '../api/myProfileApi';
import type { UpdateProfileRequest } from '../types/myProfile';

/**
 * PATCH /api/eraf/me — 기본정보 수정
 * 성공 시 ['my-profile'] 쿼리 무효화
 */
export function useUpdateMyProfile() {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: (body: UpdateProfileRequest) => myProfileApi.update(body),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['my-profile'] });
    },
  });
}
